import React, { useState } from 'react';
import '../App.css'
import { cityAttractionsService } from "../services/CityAttractionsService";
import { CityAttractionsContext } from "../contexts/CityAttractionsContext";

function DetailsModal({ tour, onClose }) {
  return (
    <div className="fixed z-10 inset-0 overflow-y-auto">
      <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center">
        <div className="fixed inset-0 transition-opacity" aria-hidden="true">
          <div className="absolute inset-0 bg-gray-500 opacity-75"></div>
        </div>

        <div className="inline-block align-middle bg-white rounded-lg p-6 w-3/5 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle">
          <button onClick={onClose} className="absolute top-2 right-2 text-2xl font-bold hover:text-red-600 transition duration-300">
            &times;
          </button>
          <h2 className="text-xl font-medium mb-4">{tour.title}</h2>
          <div className="mb-4 border-b-2 border-gray-200 pb-4">
            <div className="text-sm" dangerouslySetInnerHTML={{ __html: tour.description }} />
            <style>{`
    div > p {
      font-size: 0.875rem; /* equivalent to tailwind's text-sm */
    }
  `}</style>
          </div>
          <p className="font-semibold mb-2">Booking Engine:</p> <p>{tour.bookingEngineName}</p>
          <p className="font-semibold mb-2">Booking URL:</p> <a href={tour.bookingUrl} target="_blank" rel="noreferrer">{tour.bookingUrl}</a>
          <p className="font-semibold mb-2">Price:</p> <p>{tour.minPrice} - {tour.maxPrice} {tour.priceCurrency}</p>
          <p className="font-semibold mb-2">Location:</p> <p>{tour.geoLocation.latitude}, {tour.geoLocation.longitude}</p>
          <p className="font-semibold mb-2">Images:</p>
          {tour.galleryImages.map((img, index) => (
            <img key={index} src={img.url} alt="Gallery" className="w-1/4 m-2" />
          ))}
          <p className="font-semibold mb-2">Languages:</p> <p>{tour.availableLanguages.join(', ')}</p>
          <p className="font-semibold mb-2">Taxonomies:</p>
          {tour.taxonomies.flat().map(tax => (
            <p key={tax.uuid}>{tax.name}</p>
          ))}
          <p className="font-semibold mb-2">Cancellable:</p> <p>{tour.isCancellable ? 'Yes' : 'No'}</p>
        </div>
      </div>
    </div>
  );
}

function TourCard({ tour, onClick }) {
  return (
    <div className="mx-auto mb-4 p-6 border rounded-lg flex flex-col items-center justify-center" style={{ maxWidth: '100vh' }}>
      <h2 className="text-2xl text-red-600 text-center mb-4">{tour.title}</h2>
      <div className="text-gray-400 mb-4" dangerouslySetInnerHTML={{ __html: tour.description }} />
      <style>{`
    div > p {
      font-size: 0.875rem; /* equivalent to tailwind's text-sm */
    }
  `}</style>
      <button onClick={() => onClick(tour)} className="bg-red-600 hover:bg-red-500 text-white px-6 py-2 rounded-md transition duration-300">
        Details
      </button>
    </div>
  );
}

function TourList({ tours, onClick }) {
  return (
    <div style={{ marginTop: '20px' }}>
      {tours.map(tour => (
        <TourCard key={tour.id} tour={tour} onClick={onClick} />
      ))}
    </div>
  );
}

function LoadingOverlay() {
  return (
    <div className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="loading-spinner w-12 h-12 rounded-full border-t-4 border-blue-500"></div>
    </div>
  );
}
function CityAttractions(props) {
  const [city, setCity] = useState('');
  const [selectedTour, setSelectedTour] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { cityAttractionsState, dispatch } = React.useContext(CityAttractionsContext);
  const [isModalOpen, setModalOpen] = useState(false);

  const handleCardClick = (tour) => {
    setSelectedTour(tour);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
    setSelectedTour(null);
  };



  const handleSend = async () => {
    await cityAttractionsService.search(dispatch, city);
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen space-y-4">
      <div className="flex items-center space-x-4" style={{ marginTop: '20vh' }}>
        <input
          type="text"
          value={city}
          placeholder="Enter city name..."
          onChange={(e) => setCity(e.target.value)}
          className="border-2 border-blue-500 p-3 rounded shadow-md text-xl"
          style={{ width: '100vh', height: '6vh' }}
        />
        <button className="button button-dimensions button--primary min-w-[8rem]" onClick={handleSend}>
          Search
        </button>
        {cityAttractionsState.loading && <LoadingOverlay />}
      </div>
      <TourList tours={cityAttractionsState.tours} onClick={handleCardClick} />
      {isModalOpen && <DetailsModal tour={selectedTour} onClose={handleCloseModal} />}
    </div>
  );
}

export default CityAttractions;